import * as R from 'ramda'

export const getIsFetchingFrontendSetting = R.path([
  'setting',
  'processing',
  'getFrontendSetting'
])

export const getFrontendSetting = R.path(['setting', 'frontendSetting'])

export const getIsUpdatingFrontendSetting = R.path([
  'setting',
  'processing',
  'updatingFrontendSetting'
])
